import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadJournalReplies,
  deleteJournalReply,
} from '../../../../../state/modules/journalReplies/actions';
import { sendMessage } from '../../../../../state/actions';
import JournalRepliesList from '../components/JournalRepliesList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.journalReplies.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['journalReplies', x]),
                schema.journalReply,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              partnership_name:
                x?.journal_post?.care_guide?.partnership?.name ?? '',
              partnership_plan:
                x?.journal_post?.care_guide?.partnership?.plan?.name ?? '',
              profile_id: x.profile ? x.profile.id : '',
              profile_username:
                x.profile && x.profile.user ? x.profile.user.username : '',
              ...x,
            };
          })
      : [],
    isLoading: state.journalReplies.get('isLoading'),
    total: state.journalReplies.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadJournalReplies(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteJournalReply(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  };
};

const JournalRepliesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalRepliesList);

export default JournalRepliesListContainer;
